import Navbar from "../../components/Homepage/Navbar/Navbar";
import Footer from "../../components/Homepage/Footer/Footer";
import digitalFloraData from "../../data/digitalFloraData";
import FloraCard from "./FloraCard";

import { Box, Container, Typography } from "@mui/material";

function FloraQRGallery() {
  return (
    <>
      <Navbar />

      <Box
        sx={{
          py: 5,
          background: "#f6faf6",
          minHeight: "100vh",
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h3"
            align="center"
            fontWeight="bold"
            gutterBottom
          >
            🌿 QR Flora
          </Typography>

          <Typography
            align="center"
            color="text.secondary"
            mb={5}
          >
            Scan the QR code or click View Details to explore each plant.
          </Typography>

          {digitalFloraData.map((plant) => (
            <FloraCard key={plant.id} plant={plant} />
          ))}
        </Container>
      </Box>

      <Footer />
    </>
  );
}

export default FloraQRGallery;